import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';
import Text12 from '@sdk/components/ui/typography/Text12';

export const RowContainer = styled(Row)`
  min-height: 36px;
`;

export const LabelSection = styled(Row)`
  width: 148px;
  align-items: center;
  justify-content: flex-end;
  line-height: 36px;
`;

export const LabelText = styled(Text12)`
  line-height: 36px;
`;

export const ContentSection = styled(Row)`
  flex: 1;
`;

export const FieldContainer = styled(Column)`
  width: 100%;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
`;

export const EllipsisContainer = styled(Column)<{ width: number }>`
  flex: 1;
  inline-size: ${({ width }) => (width ? `${width}px` : '')};
`;
